<template>
  <div>
    <h3><span>뉴트리라이트가 </span><span>제안하는 추천팩으로 </span><span><strong>간편하게 신청하세요.</strong></span></h3>
    <div class="" />

    <div class="recomend_wrap">
      <!-- 2020-09-28 ul > li 구조에서 div 구조로 변경-->
      <div
        v-if="recommendationsFetched"
        class="recomend_list"
      >
        <template
          v-for="pack in recommendationPacks"
        >
          <recommend-item
            :key="pack.pack_cd"
            :pack-info="pack"
            @selected="onRecommendationSelected"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RecommendItem from '@/components/recommendation/RecommendItem.vue';
import { log } from '@/utils/common';

export default {
  name: 'HomeRecommendWrap',
  components: {
    RecommendItem,
  },
  data() {
    return {
      selectedPackCd: null,
    };
  },
  computed: {
    ...mapGetters({
      recommendationsFetched: 'recommendation/recommendationsFetched',
      recommendationPacks: 'recommendation/recommendations',
    }),
  },
  created() {
    log('HomeRecommendWrap::created', `initial selected pack code: ${this.selectedPackCd}`);
  },
  methods: {
    onRecommendationSelected(packCd) {
      this.selectedPackCd = packCd;
      log('HomeRecommendWrap::onRecommendationSelected', `selected pack code: ${this.selectedPackCd}`);

      this.$emit('selected', this.selectedPackCd);
    },
  },
};
</script>
